import Vue from 'vue'
import Vuex from 'vuex'
import incrementService from './modules/incrementService'
import { isMedicalAssociationEnv } from '../utils/envConfig'
import producePlantForm from './modules/producePlantForm'

Vue.use(Vuex)

function setPrimaryColor(isMedical) {
  const color = isMedical ? 'rgba(229, 56, 41, 1)' : '#4054af'
  document.documentElement.style.setProperty('--primary-color', color)
}

setPrimaryColor(isMedicalAssociationEnv)

export default {
  state: {
    // 是否是医学会环境（由访问路径判定，见 utils/envConfig.js）
    isMedicalAssociationEnv,
    // 是否是集群：true-集群，false-单刊（根据 MAGAZINE_INFO.type 判断：1-集群，0-单刊）
    isCluster: false
  },
  getters: {
    isMedicalAssociationEnv: (state) => state.isMedicalAssociationEnv,
    isCluster: (state) => state.isCluster
  },
  mutations: {
    setIsCluster(state, isCluster) {
      state.isCluster = isCluster
    }
  },
  actions: {
    // 更新集群/单刊状态（根据 MAGAZINE_INFO.type 判断：1-集群，0-单刊）
    updateClusterStatus({ commit }, magazineInfo) {
      const isCluster = magazineInfo && magazineInfo.type != '0'
      commit('setIsCluster', isCluster)
      let templateOptions = [
        {
          label: '整期推送',
          value: 1
        },
        {
          label: '专题推送',
          value: 2
        },
        {
          label: '单篇推送',
          value: 4
        },
        {
          label: '通知推送',
          value: 3
        }
      ]
      if (isCluster) {
        templateOptions.splice(1, 0, {
          label: '主题推送',
          value: 5
        })
      }
      commit('incrementService/settemplateOptions', templateOptions, {
        root: true
      })
    }
  },
  modules: {
    incrementService,
    producePlantForm
  }
}
